import React from "react";
import clsx from "clsx";

type Props = {
    className?: string;
};
export const Separator = ({ className }: Props) => {
    return <div className={clsx("border-b border-solid border-[var(--color-separator)] w-full", className)} />;
};
